<template>
  <section id="inneprod">
    <div v-for="item in displayedItems" :key="item.id">
      <router-link v-bind:to="{name:'itemDetails', params: {id: item.prettyId}}" id="kafbody">
        <span class="kfoto">
          <img
            v-if="item.thumbnail"
            v-bind:src="env.VUE_APP_thumbnailUrl + item.id + '/'+item.thumbnail"
            alt="prod1"
          />
          <img v-else src="../assets/img/woda1.png" alt="prod1" />
        </span>
        <span class="knazwa">{{item.name}}</span>
      </router-link>
      <span class="kkoszyk">
        <a href @click.prevent="addToCart(item)">{{ $n(item.price, 'currency') }}</a>
      </span>
    </div>
  </section>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    items: {
      type: Array
    }
  },

  data() {
    return {
      env: process.env,
      displayedItems: [],
      localItems: []
    };
  },

  computed: {},

  watch: {
    items: function(newVal) {
      this.displayedItems = [];

      //local copy
      this.localItems = [...newVal];
      // console.log("items changed ");
      this.showMoreItems();
    }
  },

  methods: {
    showMoreItems: _.throttle(function() {
      if (!this.localItems.length) return;

      // console.log("geting more results...");
      var BATCH_SIZE = 20;
      var cnt = 0;
      var item;
      while (
        cnt < BATCH_SIZE &&
        (item = this.localItems.shift()) !== undefined
      ) {
        this.displayedItems.push(item);
        cnt++;
        // console.log('copied '+cnt)
      }
      console.log("moved " + cnt);
    }, 200),

    addToCart: function(item) {
      this.$store.dispatch("addItemToCart", {
        id: item.id,
        name: item.name,
        amount: 1,
        price: item.price,
        images: [item.img]
      });
      this.$toastr("info", `1 x ${item.name}`, "Dodano do koszyka");
    }
  },

  mounted() {
    // https://alligator.io/vuejs/implementing-infinite-scroll/
    window.onscroll = () => {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >
        document.documentElement.offsetHeight - 400;
      if (this.items.length > 0 && bottomOfWindow) {
        // console.log("get more results...");
        this.showMoreItems();
      }
    };
  }
};
</script>

<style>
/* kafelki */

#inneprod div {
  width: 19%;
  margin: 0.5%;
  float: left;
  outline: 1px solid #aeaeae;
  padding-bottom: 10px;
}

#inneprod div:hover {
  box-shadow: 2px 2px 11px 1px;
}

#inneprod span {
  margin-left: 20px;
  margin-right: 20px;
  display: block;
}

.kfoto {
  text-align: center;
}

.kfoto img {
  width: 100%;
  margin: 15px auto;
}

.knazwa {
  height: 70px;
  font: normal bold 14px/17px "Times New Roman", Times, serif;
  margin: 15px;
  align-items: center;
  letter-spacing: 4px;
  color: black;
}

.kcechy {
  height: 50px;
  font: normal normal 12px/18px "Lato";
  color: black;
  border-top: 1px solid #c4c4c4;
  padding-top: 10px;
}

.kkoszyk a,
.kkoszyk a:hover {
  width: 114px;
  display: block;
  margin: 10px auto;
  color: #b2172e;
  font: normal 300 18px/32px "Lato";
  text-align: center;
  font-weight: bold;
}
</style>
